import styled from 'styled-components'

export const StyledCoreContainer = styled.div`
  position: relative;
  display: block;
  line-height: 14px;
  margin-top: 4px;
`

export const StyledCoreLabel = styled.span`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`

export const StyledInfoButton = styled.span`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-decoration-line: underline;
  margin-left: 4px;
  cursor: pointer;
`

export const StyledPopMessageContainer = styled.div`
  color: #282832;
  width: 266px;
  position: absolute;
  bottom: -2px;
  left: 40px;

  &:after {
    display: block;
    background: transparent;
    color: #fff;
    content: "▼";
    position: absolute;
    bottom: 22px;
    z-index: 12;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.32);
    font-size: 28px;
    line-height: 23px;
    left: 105px;
`
